// --- React
import React, { useMemo } from 'react';
// --- Utils
import { getSpartaDetails } from '../utils/getDetailsData';
// --- Components
import { FieldRow } from '../../components';
// --- Styles
import '../../styles.scss';

/**
 * SpartaCard (Box Office)
 *
 * Features:
 * - Displays Sparta/Box Office details in tap-ui style (horizontal label-value)
 * - Supports search/filter functionality
 *
 * @param {object} details - Product details object
 * @param {string} searchTerm - Optional search term to filter fields
 * @returns {Element}
 */
export function SpartaCard({ details, searchTerm = '' }) {
    // Function to extract Sparta details from the provided data
    const spartaDetails = useMemo(() => getSpartaDetails(details), [details]);

    // Filter fields based on search term
    const filteredFields = useMemo(() => {
        if (!searchTerm.trim()) return spartaDetails;

        const term = searchTerm.toLowerCase();
        return spartaDetails.filter(
            (field) =>
                field.label.toLowerCase().includes(term) ||
                String(field.value || '').toLowerCase().includes(term)
        );
    }, [spartaDetails, searchTerm]);

    if (filteredFields.length === 0 && searchTerm.trim()) {
        return (
            <div className="no-results">
                <i className="fa-solid fa-search" />
                <p>No fields match your search.</p>
            </div>
        );
    }

    return (
        <div className="sparta-card">
            <div className="detail-section-content">
                {filteredFields.map(({ label, value }, index) => (
                    <FieldRow
                        key={index}
                        label={label}
                        value={value}
                        noBorder={index === filteredFields.length - 1}
                    />
                ))}
            </div>
        </div>
    );
}
